module.exports = __webpack_public_path__ + "media/images/parking privé gratuit-23d11f84b5b6f8078a5c71ad53ad6401.svg";